import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type EnteredTextArgs = {
	text: string;
};

@ValidatedClass()
class EnteredTextFormData extends AbstractValidatedClass<EnteredTextArgs> {
	@constraint(Joi.string().max(200000), () => 'Le texte ne peut pas dépasser 200 000 caractères.')
	@constraint(Joi.string().trim().required(), () => 'Saisissez le texte.')
	public readonly text: string;

	constructor(data: EnteredTextArgs) {
		super(data);
		this.text = data.text;
		Object.freeze(this);
	}

	static createEmpty(): EnteredTextFormData {
		return new EnteredTextFormData({ text: '' });
	}

	setText(text: string): this {
		return this.cloneWith({ text } as Partial<EnteredTextArgs>);
	}
}

export default EnteredTextFormData;
